module.exports = __webpack_public_path__ + "static/media/18.13975805.JPG";